'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _article = require('./article');

var _article2 = _interopRequireDefault(_article);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _article2.default; /**
                                      * Created by jf on 15/12/11.
                                      */

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-weui/lib/components/article/index.js
// module id = 1724
// module chunks = 7